var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vip flex flex-center-1" }, [
    !_vm.$screen.mobile && false
      ? _c("div", { staticClass: "vipbox-main" }, [
          _c("div", { staticClass: "line" }, [
            _c("div", { staticClass: "title" }, [_vm._v("VIP等级")]),
            _c(
              "div",
              { staticClass: "content" },
              _vm._l(_vm.lastViplevel, function (i) {
                return _c("div", { key: i, staticClass: "item" }, [
                  _c(
                    "div",
                    {
                      staticClass: "vipLevel-item flex flex-center-1",
                      class: { "vipLevel-light": _vm.user.vipLevel >= i },
                    },
                    [
                      _c("img", {
                        staticClass: "userAavatar-item",
                        attrs: { src: _vm.userAavatar, alt: "" },
                      }),
                      _c("img", {
                        staticClass: "userVipIconUrl-item",
                        attrs: { src: _vm.userVipIconUrl(i), alt: "" },
                      }),
                    ]
                  ),
                ])
              }),
              0
            ),
          ]),
          _c("div", { staticClass: "line" }, [
            _c("div", { staticClass: "title" }, [_vm._v("累计金额")]),
            _c(
              "div",
              { staticClass: "content" },
              _vm._l(_vm.lastViplevel, function (i) {
                return _c("div", { key: i, staticClass: "item" }, [
                  _c("div", {
                    staticClass: "slider",
                    class: { active: _vm.user.vipLevel >= i },
                  }),
                ])
              }),
              0
            ),
          ]),
          _vm.user.nickname
            ? _c("div", { staticClass: "line" }, [
                _c("div", { staticClass: "title" }, [_vm._v("/")]),
                _c("div", { staticClass: "content" }, [
                  _vm.user.vipLevel < _vm.lastViplevel
                    ? _c(
                        "div",
                        { staticClass: "recharge-desc flex flex-ver" },
                        [
                          _vm._v(" 当前已充值: "),
                          _c("c-vip-price", {
                            attrs: { price: _vm.user.spendAmount || 0.0 },
                          }),
                          _vm._v(" 距离下一个等级还剩 "),
                          _c("c-vip-price", {
                            attrs: { price: _vm.nextNeed || 0.0 },
                          }),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "recharge-desc flex flex-ver" },
                        [
                          _vm._v(" 当前已充值: "),
                          _c("c-vip-price", {
                            attrs: { price: _vm.user.spendAmount || 0.0 },
                          }),
                          _vm._v(" 等级已达到最高 "),
                        ],
                        1
                      ),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "line" }, [
            _c("div", { staticClass: "title" }, [_vm._v("充值金额")]),
            _c(
              "div",
              { staticClass: "content" },
              _vm._l(_vm.lastViplevel, function (i) {
                return _c(
                  "div",
                  { key: i, staticClass: "item" },
                  [
                    _c("c-vip-price", {
                      attrs: { stringValue: _vm.vipCondition[i - 1] },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
          ]),
          _c("div", { staticClass: "line" }, [
            _c("div", { staticClass: "title" }, [_vm._v("每周奖励")]),
            _c(
              "div",
              { staticClass: "content" },
              _vm._l(_vm.lastViplevel, function (i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "item",
                    staticStyle: { "font-size": "12px" },
                  },
                  [
                    _c("c-vip-price", {
                      attrs: { price: _vm.vipAddOn[i - 1] },
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "btn-receive",
                        class: { active: _vm.user.vipLevel == i },
                        on: {
                          click: function ($event) {
                            return _vm.GotoRecvWeekly(i)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.user.vipLevel == i ? "前往领取" : "资格不符"
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }),
              0
            ),
          ]),
          _c("div", { staticClass: "line" }, [
            _c("div", { staticClass: "title" }, [_vm._v("升级红包")]),
            _c(
              "div",
              { staticClass: "content" },
              _vm._l(_vm.lastViplevel, function (i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "item",
                    staticStyle: { "font-size": "12px" },
                  },
                  [
                    _c("c-vip-price", {
                      attrs: { stringValue: _vm.vipGift[i - 1] },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
          ]),
          _c("div", { staticClass: "line" }, [
            _c("div", { staticClass: "title" }, [_vm._v("专属红包")]),
            _c(
              "div",
              { staticClass: "content" },
              _vm._l(_vm.lastViplevel, function (i) {
                return _c("div", { key: i, staticClass: "item" }, [
                  _c(
                    "span",
                    {
                      staticClass: "btn-receive",
                      class: { active: _vm.user.vipLevel >= i },
                      on: {
                        click: function ($event) {
                          return _vm.GotoReceive(i)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.user.vipLevel >= i ? "前往领取" : "继续努力"
                          )
                      ),
                    ]
                  ),
                ])
              }),
              0
            ),
          ]),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "vipbox-mobile" },
      [
        _vm._l(_vm.lastViplevel, function (i) {
          return [
            i >= _vm.user.vipLevel
              ? _c(
                  "div",
                  {
                    key: i,
                    staticClass: "vipbox-item",
                    class: { "vipbox-item-noactive": _vm.user.vipLevel < i },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "vipbox-item-top flex flex-jcsb flex-ais",
                      },
                      [
                        _c("div", { staticClass: "vipbox-item-top-left" }, [
                          _c("div", { staticClass: "vip-bold" }, [
                            _vm._v("VIP " + _vm._s(i)),
                          ]),
                          _c(
                            "div",
                            { staticClass: "vip-text flex flex-ver" },
                            [
                              _vm._v(" 当前战力值: "),
                              _c("c-vip-price", {
                                attrs: { price: _vm.user.spendAmount || 0.0 },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "vipbox-item-top-right flex flex-col flex-center-1",
                          },
                          [
                            _c("div", { staticClass: "vip-icon" }, [
                              _c("img", {
                                staticClass: "userAavatar-item-1",
                                attrs: { src: _vm.userAavatar, alt: "" },
                              }),
                              _c("img", {
                                staticClass: "userVipIconUrl-item-1",
                                attrs: { src: _vm.userVipIconUrl(i), alt: "" },
                              }),
                            ]),
                            false
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "vipbox-item-top-right-text flex flex-col fllex-center-1",
                                  },
                                  [
                                    _c("span", [_vm._v("VIP周奖励箱")]),
                                    _c(
                                      "div",
                                      { staticClass: "flex flex-ver" },
                                      [
                                        _c("c-svg", {
                                          staticStyle: {
                                            "margin-left": "6px",
                                            "margin-right": "3px",
                                          },
                                          attrs: {
                                            src: "coin-2159.svg",
                                            width: "12",
                                            height: "12",
                                            fill: "#827dff",
                                          },
                                        }),
                                        _vm._v(
                                          _vm._s(_vm.vipGift[i - 1]) + " "
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "vipbox-item-center" }, [
                      i == _vm.user.vipLevel && i != 12
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "vipbox-item-center-top flex flex-ver",
                            },
                            [
                              _vm._v(" 距离下一个等级还剩"),
                              _c("c-vip-price", {
                                attrs: { price: _vm.nextNeed || 0.0 },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      i == _vm.user.vipLevel && i == 12
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "vipbox-item-center-top flex flex-ver",
                            },
                            [_vm._v(" 到达最高等级 ")]
                          )
                        : _vm._e(),
                      i > _vm.user.vipLevel && _vm.user.vipLevel != 12
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "vipbox-item-center-top flex flex-ver",
                            },
                            [
                              _vm._v(" 距离当前所需战力"),
                              _c("c-vip-price", {
                                attrs: { price: _vm.currentNeed(i) || 0.0 },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("div", { staticClass: "vipbox-item-center-center" }, [
                        _c("div", {
                          staticClass: "vipbox-item-center-center-active",
                          style: {
                            width: _vm.vipStepWidth(i),
                          },
                        }),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "vipbox-item-center-bottom flex flex-center-2",
                        },
                        [
                          _c("p", [_vm._v(_vm._s(_vm.vipCondition[i - 1]))]),
                          _c("p", [_vm._v(_vm._s(_vm.vipCondition[i]))]),
                        ]
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "vipbox-item-bottom flex flex-center-3" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "vipbox-item-bottom-btn flex flex-center-1",
                            class: { btndisabled: _vm.user.vipLevel != i },
                            on: {
                              click: function ($event) {
                                return _vm.openUpgradeCase(i)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.user.vipLevel == i
                                    ? "VIP升级箱"
                                    : "资格不符"
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "vipbox-item-bottom-btn flex flex-center-1",
                            class: { btndisabled: _vm.user.vipLevel < i },
                            on: {
                              click: function ($event) {
                                return _vm.openWeeklyCase(i)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.user.vipLevel >= i
                                    ? "VIP周奖励箱"
                                    : "继续努力"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }